import { createSlice } from '@reduxjs/toolkit';

const viewportSlice = createSlice({
  name: 'viewport',
  initialState: {
    isDesktopView: window.innerWidth >= 1024,
    // isTabletView: window.innerWidth >= 768 && window.innerWidth < 1024,
    isMobileView: window.innerWidth < 1024,
  },
  reducers: {
    setViewport: (state, action) => {
      const width = action.payload;
      state.isDesktopView = width >= 1024;
      state.isMobileView = width < 1024;
    },
  },
});

export const { setViewport } = viewportSlice.actions;
export default viewportSlice.reducer;
